module.exports = __webpack_public_path__ + "static/img/QLD-8.2e27876.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-8.jpg
// module id = 0JMj
// module chunks = 0